import React from 'react';

const COLORS = [
  { id: 'white', label: 'White', hex: '#ffffff', border: '#999' },
  { id: 'teal', label: 'Petrol', hex: '#2f778a', border: '#2f778a' },
  { id: 'yellow', label: 'Yellow', hex: '#e8a817', border: '#c08a10' },
  { id: 'purple', label: 'Purple', hex: '#82378c', border: '#5a2261' },
];

const ContactColorWidget = ({ id, value, onChange }) => {
  const current = value || 'teal';

  return (
    <div className="fcmh-color-widget">
      {COLORS.map((c) => {
        const active = current === c.id;
        return (
          <button
            key={c.id}
            type="button"
            className={`fcmh-color-widget__option${active ? ' is-active' : ''}`}
            style={{
              backgroundColor: c.hex,
              borderColor: active ? '#d00' : c.border,
            }}
            onClick={() => onChange(id, c.id)}
            title={c.label}
            aria-pressed={active}
          >
            {active && <span className="fcmh-color-widget__dot" />}
          </button>
        );
      })}
    </div>
  );
};

export default ContactColorWidget;
